// @ts-nocheck
import { optionsFetchGamesPublic } from "@/config/plugins/queryOptions.reactquery.ts";
import {
  BaseResponse,
  PaginationResponse,
} from "@/integration/application/interfaces/base.ts";
import { IGame } from "@/integration/game/interfaces/game.interface.ts";
import { useQuery } from "@tanstack/react-query";

const useGamePublic = () => {
  const { data: listGames } = useQuery(optionsFetchGamesPublic());

  function mapToGameFilter(
    data: PaginationResponse<BaseResponse<IGame>>
  ): { id: string; name: string; icon: string | null; selected: boolean }[] {
    return data.data.map((item) => {
      const { id, name } = item.entity;

      const iconFile = item.files.find(
        (file: any) => file.business_type === "GAMES_ICON"
      );
      const icon = iconFile ? iconFile.url : null;

      return {
        id,
        name,
        icon,
        selected: false,
      };
    });
  }

  const gamesFilter: {
    id: string;
    name: string;
    icon: string | null;
    selected: boolean;
  }[] = listGames ? mapToGameFilter(listGames) : [];

  return { gamesFilter };
};

export default useGamePublic;
